

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    data: null,
    investor_types: [],
    is_subscribed: null,
    all_plans: null,
    loading_plans: false,
    current_plan: ""
}

const startupDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_STARTUP_DETAILS:
            return {
                ...state,
                data: action.data
            }
        case actionTypes.SET_INVESTOR_TYPES:
            return {
                ...state,
                investor_types: action.investor_types
            }
        case actionTypes.SET_IS_SUBSCRIBED:
            return {
                ...state,
                is_subscribed: action.is_subscribed,
                current_plan: action.current_plan,
                subscription_details: action.subscription_details,
                loading_subscription: action.loading_subscription
            }
        case actionTypes.SET_ALL_PLANS_DATA:
            return {
                ...state,
                all_plans: action.all_plans,
                loading_plans: action.loading_plans
            }
        default:
            return state;
    }
}

export default startupDetailsReducer
